var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKeyboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15C3.0875 15 2.73438 14.8531 2.44063 14.5594C2.14688 14.2656 2 13.9125 2 13.5V6.5C2 6.0875 2.14688 5.73438 2.44063 5.44063C2.73438 5.14688 3.0875 5 3.5 5H16.5C16.9125 5 17.2656 5.14688 17.5594 5.44063C17.8531 5.73438 18 6.0875 18 6.5V13.5C18 13.9125 17.8531 14.2656 17.5594 14.5594C17.2656 14.8531 16.9125 15 16.5 15H3.5ZM3.5 13.5H16.5V6.5H3.5V13.5ZM7 13H13V11.5H7V13ZM5 10.5H6.5V9H5V10.5ZM7.125 10.5H8.625V9H7.125V10.5ZM9.25 10.5H10.75V9H9.25V10.5ZM11.375 10.5H12.875V9H11.375V10.5ZM13.5 10.5H15V9H13.5V10.5ZM5 8.5H6.5V7H5V8.5ZM7.125 8.5H8.625V7H7.125V8.5ZM9.25 8.5H10.75V7H9.25V8.5ZM11.375 8.5H12.875V7H11.375V8.5ZM13.5 8.5H15V7H13.5V8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKeyboard);
export default __webpack_public_path__ + "static/media/ic-keyboard.8f73dbcaade147b8e15efc9a6da54208.svg";
export { ForwardRef as ReactComponent };